import { FormlyFieldConfig } from '@ngx-formly/core';
import { RxDocument, RxCollection, RxJsonSchema, RxCollectionCreator } from 'rxdb';

export interface AuthenticationSchemaDocType {
  agent_id: string;
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: number;
  scope: string;
  agency_id: number;
  contact_id: number;
  program_ids?: any;
  participant_ids: Array<number>;
  jti: string;
  max_idle: number;
}

export const authenticationSchema: RxJsonSchema<AuthenticationSchemaDocType> = {
  title: 'Authentication',
  description: 'this is the authentication schema',
  version: 0,
  keyCompression: true,
  type: 'object',
  properties: {
      agent_id: {
        type: 'string',
        primary: true
      },
      access_token: {
        type: 'string',
        encrypted: true
      },
      token_type: {
        type: 'string',
        encrypted: true
      },
      refresh_token: {
        type: 'string',
        encrypted: true
      },
      expires_in: {
        type: 'number',
        encrypted: true
      },
      scope: {
        type: 'string',
        encrypted: true
      },
      agency_id: {
        type: 'number',
        encrypted: true
      },
      contact_id: {
        type: 'number',
        encrypted: true
      },
      program_ids: {
        type: 'array',
        encrypted: true
      },
      participant_ids: {
        type: 'array',
        encrypted: true
      },
      jti: {
        type: 'string',
        encrypted: true
      },
      max_idle: {
        type: 'number',
        encrypted: true
      }
  }
};

export type AuthenticationSchemaDocument = RxDocument<AuthenticationSchemaDocType>;
export type AuthenticationSchemaCollection = RxCollection<AuthenticationSchemaDocType>;

export const authenticationCollection: RxCollectionCreator = {
  name: 'auth',
  schema: authenticationSchema
};
